/**
 * `:::quiz` の「答えを見る」トグル（05_ui.md §6.4 / 08_directive-syntax.md §4.5）。
 */

const LABEL_SHOW = "答えを見る";
const LABEL_HIDE = "答えを隠す";

function initSingle(root: HTMLElement): void {
  if (root.dataset["lmsQuizReady"] === "1") return;
  root.dataset["lmsQuizReady"] = "1";

  const toggle = root.querySelector<HTMLButtonElement>("[data-lms-quiz-toggle]");
  const answer = root.querySelector<HTMLElement>("[data-lms-quiz-answer]");
  if (!toggle || !answer) return;

  if (!answer.hidden || toggle.getAttribute("aria-expanded") !== "false") {
    console.warn("[lms-quiz] 初期状態がサーバー出力と一致しません", root);
  }

  toggle.addEventListener("click", () => {
    const opening = answer.hidden;
    answer.hidden = !opening;
    toggle.setAttribute("aria-expanded", String(opening));
    toggle.textContent = opening ? LABEL_HIDE : LABEL_SHOW;
  });
}

export function initQuiz(scope: ParentNode = document): void {
  scope.querySelectorAll<HTMLElement>("[data-lms-quiz]").forEach((root) => {
    initSingle(root);
  });
}
